import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/scoreExchange';

const initialState = Immutable.fromJS({
  data: [],
  export: {},
  loading: false,
  loaded: false
})

export default handleActions({
  // 查询兑换列表
  [actions.getScoreExchangeSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getScoreExchangeFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  // 确认收货
  [actions.confirmSucceeded](state) {
    return state.delete('error').set('loading', true)
  },
  [actions.confirmFailed](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  // 导出兑换列表
  [actions.getScoreExchangeExportRequested](state) {
    return state.delete('error').set('loading', true)
  },
  [actions.getScoreExchangeExportSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true).update('export', v => v.merge(Immutable.fromJS(payload)));
  },
  [actions.getScoreExchangeExportFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/scoreExchange.js